import IconEosLoading from "~icons/eos-icons/loading.svg";

import { render } from "solid-js/web";

// 假设这个是 Solid 组件

let loadingCount = 0; // 用于追踪 loading 状态的计数器

export function showLoading() {
  if (loadingCount === 0) {
    // 只有第一次调用时才会显示 loading
    const container = document.createElement("div");
    container.id = "global-loading-container"; // 给 container 一个唯一的 ID

    container.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9999;
      width: 100vw;
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.6);
    `;

    document.body.appendChild(container); // 将 loading 插入到 body 中

    // 使用 Solid 的 render 函数将 Solid 组件渲染到 container 上
    render(
      () => (
        <div>
          <IconEosLoading class="text-general-main h-10 w-10" />
        </div>
      ),
      container,
    ); // render 函数将组件渲染到 container 上
  }

  loadingCount++;
}

export function hideLoading() {
  if (loadingCount > 0) {
    loadingCount--;
  }

  if (loadingCount === 0) {
    // 当没有其他地方需要 loading 时，隐藏 loading
    const container = document.getElementById("global-loading-container");
    if (container) {
      document.body.removeChild(container);
    }
  }
}
